import { useLoadingState, useMonkTheme } from '@monkvision/common';
import { Button } from '@monkvision/common-ui-web';
import { useMonitoring } from '@monkvision/monitoring';
import { useTranslation } from 'react-i18next';
import { useDownloadPictures } from '../../../hooks/useDownloadPictures/useDownloadPictures';
import { TeslaInspection } from '../../../hooks/useTeslaInspectionList/types';
import { styles } from './DownloadPicturesButton.styles';

export interface DownloadPicturesButtonProps {
  inspection: TeslaInspection;
}

export function DownloadPicturesButton({ inspection }: DownloadPicturesButtonProps) {
  const loading = useLoadingState();
  const { handleError } = useMonitoring();
  const { palette } = useMonkTheme();
  const { t } = useTranslation();
  const { downloadPictures } = useDownloadPictures();

  const handleDownloadPictures = async () => {
    loading.start();
    try {
      await downloadPictures(inspection);
      loading.onSuccess();
    } catch (err) {
      handleError(err);
      loading.onError(err);
    }
  };

  return (
    <Button
      onClick={handleDownloadPictures}
      icon='file-download'
      loading={loading}
      variant='text'
      primaryColor={palette.text.black}
      style={styles['downloadPicturesButton']}
    >
      {t('inspectionReview.downloadPictures').toUpperCase()}
    </Button>
  );
}
